import { createVNode as _createVNode, isVNode as _isVNode } from "vue";
import { defineComponent } from 'vue';
import { ConfigProvider } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const Wrapper = defineComponent({
  name: 'ElfWrapper',
  setup(props, {
    slots
  }) {
    return () => _createVNode(ConfigProvider, {
      "prefixCls": "elf",
      "locale": zhCN
    }, _isSlot(slots) ? slots : {
      default: () => [slots]
    });
  }
});
export default Wrapper;